export const createSsoLoginForm = () => {
  return `<!DOCTYPE html><HTML><BODY Onload="document.forms[0].submit()"> 
        <FORM METHOD="POST" ACTION="https://www.madkom.pl"><INPUT TYPE="HIDDEN" NAME="SAMLRequest" VALUE="test-value"/>
      <NOSCRIPT><P>JavaScript jest wyłączony. Rekomendujemy włączenie. Aby kontynuować, proszę nacisnąć przycisk poniżej.</P><INPUT TYPE="SUBMIT" VALUE="Kontynuuj" /></NOSCRIPT>
      </FORM></BODY></HTML>`;
};
